export const SET_UPDATE_FLAG = "SET_UPDATE_FLAG";
export const GET_APP_VERSION = "GET_APP_VERSION";
export const SET_DEMOGRAPHICS = "SET_DEMOGRAPHICS";
export const TRIGGER_DEEP_UPDATE = "TRIGGER_DEEP_UPDATE";
export const DEEP_UPDATE_COMPLETE = "DEEP_UPDATE_COMPLETE";
export const SET_DEVICE_NAME = "SET_DEVICE_NAME";
